import React from 'react'



const ConferenceAgenda = () => (
<section id="agenda" className="parallax-section">
	<div className="container">
    <br /><br /><br /><br /><br />
		<div className="row">
        <div className="col-md-offset-2 col-md-8 col-sm-offset-2 col-sm-8">
				<div className="header-title">
					<h3 className="heading">Agenda</h3>
					<hr />
					<p>
						2020 Edition schedule - this is a draft and it can change without notice.<br />
						* Please note lunch is not provided.
					</p>
				</div>
			</div>
			<div className="col-md-12 col-sm-6 wow fadeInUp">
				<div className="team-wrapper">
					<div className="team-des agenda-center">
						<h4>8:00 - 9:00</h4>
						<h5>REGISTRATION</h5>
					</div>
				</div>
			</div>
			<div className="col-md-12 col-sm-6 wow fadeInUp animated">
				<div className="team-wrapper">
					<div className="team-des agenda-center">
						<h4>9:00 - 9:10</h4>
						<h5>CONFERENCE OPENING</h5>
						<p><b>&nbsp;</b></p>
					</div>
				</div>
			</div>
			<div className="col-md-12 col-sm-6 wow fadeInUp animated">
				<div className="team-wrapper">
					<div className="team-des agenda-center">
						<h4>9:10 - 9:55</h4>
						<h5><a href="/speakers/mathias-verraes">Opening keynote</a></h5>
						<b><a href="/speakers/mathias-verraes">Mathias Verraes</a></b>
						<p><a href="/speakers/mathias-verraes">Temporal Coupling</a></p>
					</div>
				</div>
			</div>
			<div className="col-md-12 col-sm-6 wow fadeInUp animated">
				<div className="team-wrapper">
					<div className="team-des agenda-center">
						<h4>9:55 - 10:25</h4>
						<h5>COFFEE BREAK & TRACKS SEPARATION</h5>
					</div>
				</div>
			</div>
			<div className="col-md-4 col-sm-6 wow fadeInUp">
				<div className="team-wrapper">
					<div className="team-des agenda-center">
						<h4>CLOUD NATIVE</h4>
					</div>
				</div>
				<div className="team-wrapper">
					<div className="team-des agenda-center-track">
						<h4>10:25 - 10:30</h4>
						<b><a href="/tracks/cloudnative">Track Powered By Mambu</a></b>
						<br /><a href="/tracks/cloudnative">opening by host</a><br />
						<b><a href="https://www.linkedin.com/in/pavelchunyayev/" target="_blank">Pavel Chunyayev</a></b>
					</div>						
				</div>
			</div>
			<div className="col-md-4 col-sm-6 wow fadeInUp">
				<div className="team-wrapper">
					<div className="team-des agenda-center">
						<h4>ARCHITECTURE</h4>
					</div>
				</div>				
				<div className="team-wrapper">
                    <div className="team-des agenda-center-track">
						<h4>10:25 - 10:30</h4>
						<b><a href="/tracks/architecture">Track Powered By Centric</a></b> 
						<br /><a href="/tracks/architecture">opening by host</a><br />
						<b>&nbsp;</b>
                    </div>
				</div>
			</div>
			<div className="col-md-4 col-sm-6 wow fadeInUp">
				<div className="team-wrapper">
					<div className="team-des agenda-center">
						<h4>SECURITY</h4>
					</div>
				</div>				
				<div className="team-wrapper">
					<div className="team-des agenda-center-track">
						<h4>10:25 - 10:30</h4>
						<b><a href="/tracks/security">Track Powered by Cognizant Softvision</a></b>
						<br /><a href="/tracks/security">opening by host</a><br />
						<b>&nbsp;</b>
					</div>
				</div>
			</div>
            <div className="col-md-12 col-sm-6 wow fadeInUp animated">
				<div className="team-wrapper">
					<div className="team-des agenda-center">
						&nbsp;
					</div>
				</div>
			</div>
			<div className="col-md-4 col-sm-6 wow fadeInUp">
				<div className="team-wrapper">
					<div className="team-des agenda-center-track">
						<h4>10:30 - 11:15</h4>
						<b><a href="/speakers/cezar-romaniuc">Cezar Romaniuc</a></b>
						<p><a href="/speakers/cezar-romaniuc">Incremental transition from monolith to microservices</a></p>
					</div>						
				</div>
			</div>
			<div className="col-md-4 col-sm-6 wow fadeInUp">
				<div className="team-wrapper">
                    <div className="team-des agenda-center-track">
						<h4>10:30 - 11:15</h4>
						<b><a href="/speakers/tudor-teodoru">Tudor Teodoru</a></b>
						<p><a href="/speakers/tudor-teodoru">How do you know if you're building what you designed?</a></p>
                    </div>
				</div>
			</div>
			<div className="col-md-4 col-sm-6 wow fadeInUp">
				<div className="team-wrapper">
					<div className="team-des agenda-center-track">
                        <h4>10:30 - 11:15</h4>
                        <b><a href="/speakers/leif-nixon">Leif Nixon</a></b>
                        <p><a href="/speakers/leif-nixon">HORRORLARITY</a></p>
					</div>
				</div>
			</div>
			<div className="col-md-12 col-sm-6 wow fadeInUp animated">
				<div className="team-wrapper">
					<div className="team-des agenda-center">
						&nbsp;
					</div>
				</div>
			</div>			
            <div className="col-md-12 col-sm-6 wow fadeInUp animated">
				<div className="team-wrapper">
					<div className="team-des agenda-center">
						<h4>11:15 - 11:30</h4>
						<h5>COFFEE BREAK</h5>
					</div>
				</div>
			</div>
			<div className="col-md-4 col-sm-6 wow fadeInUp">
				<div className="team-wrapper">
					<div className="team-des agenda-center">
						<h4>CLOUD NATIVE</h4>
					</div>
				</div>
				<div className="team-wrapper">
					<div className="team-des agenda-center-track">
						<h4>11:30 - 12:15</h4>
						<b><a href="/speakers/adrian-mouat">Adrian Mouat</a></b>
						<p><a href="/speakers/adrian-mouat">Establishing Image Provenance and Security in Kubernetes</a></p>
					</div>						
				</div>
			</div>
			<div className="col-md-4 col-sm-6 wow fadeInUp">
				<div className="team-wrapper">
					<div className="team-des agenda-center">
						<h4>ARCHITECTURE</h4>
					</div>
				</div>				
				<div className="team-wrapper">
                    <div className="team-des agenda-center-track">
						<h4>11:30 - 12:15</h4>
						<b><a href="/speakers/nick-tune">Nick Tune</a></b>
						<p><a href="/speakers/nick-tune">Sociotechnical domain-driven design: Aligning teams and software for continuous delivery</a></p>
                    </div>
				</div>
			</div>
			<div className="col-md-4 col-sm-6 wow fadeInUp">
				<div className="team-wrapper">
					<div className="team-des agenda-center">
						<h4>SECURITY</h4>
					</div>
				</div>				
				<div className="team-wrapper">
					<div className="team-des agenda-center-track">
						<h4>11:30 - 12:15</h4>
						<b><a href="/speakers/vicentiu-bacioiu">Vicentiu Bacioiu</a></b>
						<p><a href="/speakers/vicentiu-bacioiu">OAuth Unlocked - How it actually works</a></p>
					</div>
				</div>
			</div>
			<div className="col-md-12 col-sm-6 wow fadeInUp animated">
				<div className="team-wrapper">
					<div className="team-des agenda-center">
					</div>
				</div>
			</div>   			
			<div className="col-md-12 col-sm-6 wow fadeInUp animated">
				<div className="team-wrapper">
					<div className="team-des agenda-center">
						<h4>12:15 - 13:45</h4>
						<h5>LUNCH BREAK (lunch not provided) & NETWORKING</h5>
					</div>
				</div>
			</div>
			<div className="col-md-4 col-sm-6 wow fadeInUp">
				<div className="team-wrapper">
					<div className="team-des agenda-center">
						<h4>CLOUD NATIVE</h4>
					</div>
				</div>
				<div className="team-wrapper">
					<div className="team-des agenda-center-track">
						<h4>13:45 - 14:30</h4>
						<b><a href="#">Cloud Native Panel</a></b>
					</div>						
				</div>
			</div>
			<div className="col-md-4 col-sm-6 wow fadeInUp">
				<div className="team-wrapper">
					<div className="team-des agenda-center">
						<h4>ARCHITECTURE</h4>
					</div>
				</div>				
				<div className="team-wrapper">
                    <div className="team-des agenda-center-track">
						<h4>13:45 - 14:30</h4>
						<b><a href="#">Architecture Panel</a></b>
                    </div>
				</div>
			</div>
			<div className="col-md-4 col-sm-6 wow fadeInUp">
				<div className="team-wrapper">
					<div className="team-des agenda-center">
						<h4>SECURITY</h4>
					</div>
				</div>				
				<div className="team-wrapper">
					<div className="team-des agenda-center-track">
						<h4>13:45 - 14:30</h4>
						<b><a href="#">Security Panel</a></b>
					</div>
				</div>
			</div>
			<div className="col-md-12 col-sm-6 wow fadeInUp animated">
				<div className="team-wrapper">
						<div className="team-des agenda-center">
						</div>
				</div>
			</div>            
            <div className="col-md-12 col-sm-6 wow fadeInUp animated">
				<div className="team-wrapper">
						<div className="team-des agenda-center">
							<h4>14:30 - 14:45</h4>
							<h5>COFFEE BREAK</h5>
						</div>
				</div>
			</div>
			<div className="col-md-4 col-sm-6 wow fadeInUp">
				<div className="team-wrapper">
					<div className="team-des agenda-center">
						<h4>CLOUD NATIVE</h4>
					</div>
				</div>
				<div className="team-wrapper">
					<div className="team-des agenda-center-track">
						<h4>14:45 - 15:30</h4>
						<b><a href="/speakers/andrew-martin">Andrew Martin</a></b>
						<p><a href="/speakers/andrew-martin">In a Container Nobody Hears Your Screams: Next Generation Process Isolation</a></p>
					</div>						
				</div>
			</div>
			<div className="col-md-4 col-sm-6 wow fadeInUp">
				<div className="team-wrapper">
					<div className="team-des agenda-center">
						<h4>ARCHITECTURE</h4>
					</div>
				</div>				
				<div className="team-wrapper">
                    <div className="team-des agenda-center-track">
						<h4>14:45 - 15:30</h4>
						<b><a href="/speakers/tomer-gabel">Tomer Gabel</a></b>
						<p><a href="/speakers/tomer-gabel">Microservices: A retrospective</a></p>
                    </div>
				</div>
			</div>
			<div className="col-md-4 col-sm-6 wow fadeInUp">
				<div className="team-wrapper">
					<div className="team-des agenda-center">
						<h4>SECURITY</h4>
					</div>
				</div>				
				<div className="team-wrapper">
					<div className="team-des agenda-center-track">
						<h4>14:45 - 15:30</h4>
						<b><a href="/speakers/philippe-deryck">Philippe De Ryck</a></b>
						<p><a href="/speakers/philippe-deryck">Common API security pitfalls</a></p>
					</div>
				</div>
			</div>
			<div className="col-md-12 col-sm-6 wow fadeInUp animated">
				<div className="team-wrapper">
						<div className="team-des agenda-center">
						</div>
				</div>
			</div>            
            <div className="col-md-12 col-sm-6 wow fadeInUp animated">
				<div className="team-wrapper">
					<div className="team-des agenda-center">
						<h4>15:30 - 15:45</h4>
						<h5>COFFEE BREAK</h5>
					</div>
				</div>
			</div>
            <div className="col-md-4 col-sm-6 wow fadeInUp">
				<div className="team-wrapper">
					<div className="team-des agenda-center">
						<h4>CLOUD NATIVE</h4>
					</div>
				</div>
				<div className="team-wrapper">
					<div className="team-des agenda-center-track">
						<h4>15:45 - 16:30</h4>
						<b><a href="#">TBA</a></b>
						<p><a href="#">TBA</a></p>
					</div>						
				</div>
			</div>
			<div className="col-md-4 col-sm-6 wow fadeInUp">
				<div className="team-wrapper">
					<div className="team-des agenda-center">
						<h4>ARCHITECTURE</h4>
					</div>
				</div>
				<div className="team-wrapper">
                    <div className="team-des agenda-center-track">
						<h4>15:45 - 16:30</h4>
						<b><a href="/speakers/vladik-khononov">Vladik Khononov</a></b>
						<p><a href="/speakers/vladik-khononov">Microservices, bounded contexts, and everything in between</a></p>
                    </div>
				</div>
			</div>
			<div className="col-md-4 col-sm-6 wow fadeInUp">
				<div className="team-wrapper">
					<div className="team-des agenda-center">
						<h4>SECURITY</h4>
					</div>
				</div>				
				<div className="team-wrapper">
					<div className="team-des agenda-center-track">
						<h4>15:45 - 16:30</h4>
						<b><a href="/speakers/christian-wenz">Christian Wenz</a></b>
						<p><a href="/speakers/christian-wenz">The Ten Most Critical Web Application Security Risks: OWASP Top Ten</a></p>
					</div>
				</div>
			</div>
			<div className="col-md-12 col-sm-6 wow fadeInUp animated">
				<div className="team-wrapper">
					<div className="team-des agenda-center">
					</div>
				</div>
			</div>            
            <div className="col-md-12 col-sm-6 wow fadeInUp animated">
				<div className="team-wrapper">
					<div className="team-des agenda-center">
						<h4>16:30 - 16:45</h4>
						<h5>COFFEE BREAK</h5>
					</div>
				</div>
			</div>
			<div className="col-md-12 col-sm-6 wow fadeInUp animated">
				<div className="team-wrapper">
					<div className="team-des agenda-center">
						<h4>16:45 - 17:30</h4>
						<h5><a href="/speakers/nicky-wrightson">Closing keynote</a></h5>
						<b><a href="/speakers/nicky-wrightson">Nicky Wrightson</a></b>
						<p><a href="/speakers/nicky-wrightson">An Engineer's Guide to a Good Night's Sleep</a></p>
					</div>
				</div>
			</div> 
			<div className="col-md-12 col-sm-6 wow fadeInUp animated">
				<div className="team-wrapper">
					<div className="team-des agenda-center">
					</div>
				</div>
			</div>            
            <div className="col-md-12 col-sm-6 wow fadeInUp animated">
				<div className="team-wrapper">
					<div className="team-des agenda-center">
						<h4>17:30 - 18:30</h4>
						<h5>GEEK PARTY & NETWORKING</h5>
					</div>
				</div>
			</div>                     
		</div>
	</div>
</section>
)

export default ConferenceAgenda



// WEBPACK FOOTER //
// ./src/pages/agenda.js